import CommonService from '../../../../services/commonService';
import DateService from '../../../../services/dateService';
import React from 'react';

function KuposGoBodyItem(props) {
  return (
    <div key={props.keyValue}>
      <div>
        {props.val.heading && (
          <div className="my-trips-title">
            <span>{props.val.heading}</span>
          </div>
        )}

        <div className="kupos-card my-trips-item font9">
          <div className="display-flex">
            <div style={{ width: '80%' }}>
              <div className="my-trips-sub-item less-bold-text font11">
                {CommonService.normalizeAddress(props.val.pickup_address) +
                  ' - ' +
                  props.val.drop_address}
              </div>
              <span className="individual-line font9">
                {DateService.changeDateFormat(
                  props.val.travel_date.split(' ')[0],
                  'yyyy-mm-dd',
                  'dd/mm/yyyy',
                )}
                {/* {DateService.getMyTripsDateFormat(val.travel_date)} */}
              </span>
              <br />
              <span className="individual-line font9">
                {props.t('PROFILE.VEHICLE_TYPE')}: {props.val.vehicle_type}
              </span>
            </div>

            <div className="right-section-trips-item">
              <div className="float-right">
                <div
                  className="primary-text less-bold-text see-more-trip-details"
                  onClick={() => props.onSeeMoreClickedKuposGo(props.val, props.keyValue)}
                >
                  {props.t('PROFILE.VIEW_MORE')}
                  <span className="sub-section-my-trips-strip-arrow-icon">
                    <img src="/images/icons/home/icon_arrow_down.png" alt="" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={
          'sub-body-my-trips font10 ' +
          'light-grey-text ' +
          (props.keyValue == props.selectedTripItem ? 'show' : 'hide')
        }
      >
        {console.log('Selected KuposGo ticket------------', props.ticketDetailsKuposGo)}
        {!props.busTicketLoading && props.ticketDetailsKuposGo ? (
          <div>
            <span className="sub-body-my-trips-title primary-text-color bold-text font10">
              {props.t('PROFILE.TRIP_DETAIL')}
            </span>
            <div className="sub-body-sub-item ">
              <div>
                <div>
                  <span className="bold-text font10">{props.t('PROFILE.TRAVEL_DATE')}</span> <br />
                  <span className="font10">
                    {DateService.changeDateFormat(
                      props.ticketDetailsKuposGo.travel_date,
                      'yyyy-mm-dd',
                      'dd/mm/yyyy',
                    )}
                  </span>
                </div>
              </div>

              <div>
                <div>
                  <span className="bold-text font10">{props.t('PROFILE.TRANSACTION_NUMBER')}</span>{' '}
                  <br />
                  <span className="font10">{props.ticketDetailsKuposGo.pnr_number}</span>
                </div>
              </div>
            </div>
            <hr className="horizontal-line" />
            <div>
              <span className="bold-text font10">{props.t('PROFILE.DEPARTURE_POINT')}</span>
              <ul className="sub-item-list font10">
                <li>
                  {CommonService.normalizeAddress(props.ticketDetailsKuposGo.pickup_address)}{' '}
                  {/* -{' '}
                        {DateService.getMyTripsDateFormat(props.ticketDetailsKuposGo.travel_time)} */}
                </li>
              </ul>
              <span className="bold-text font10">{props.t('PROFILE.ARRIVAL_POINT')}</span>
              <ul className="sub-item-list font10">
                <li>
                  {CommonService.normalizeAddress(props.ticketDetailsKuposGo.drop_address)} -{' '}
                </li>
              </ul>

              <div className="sub-body-sub-item">
                <div>
                  <div>
                    <span className="font10">
                      {props.t('PROFILE.SERVICE_TYPE')}:{' '}
                      {props.ticketDetailsKuposGo.type_of_service}
                    </span>
                  </div>
                </div>

                <div>
                  <div>
                    <span className="font10">
                      {props.t('PROFILE.SEATS')}: {props.ticketDetailsKuposGo.no_of_passengers}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <hr className="horizontal-line" />
            <div className="sub-body-sub-item">
              <div>
                <div>
                  <span className="bold-text font10">
                    {/* {props.t('PROFILE.QUALIFICATION')} */}
                    {props.t('PROFILE.VEHICLE_TYPE')}
                  </span>{' '}
                  <br />
                  <span className="font10">{props.ticketDetailsKuposGo.vehicle_type}</span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="loading-bus-ticket-details">{props.t('CANCEL_TICKET.LOADING')}</div>
        )}
      </div>
    </div>
  );
}

export default KuposGoBodyItem;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyTrips/components/KuposGoBodyItem.js